import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import Charts from "./charts";
import FundDetails from "./FundDetails";
import FundGrowthChart from "./FundGrowthChart";
import RequestReport from "./RequestReport";
import UploadReport from "./UploadReport";
// import report from "./report";

const LongTerm = () => {
  const [report, setReport] = useState(null);

  return <Grid container spacing={2}>
    <Grid item md={1} xs={12}></Grid>
    <Grid item md={4} xs={12}>
      <RequestReport/>
    </Grid>
    <Grid item md={2} xs={12}></Grid>
    <Grid item md={4} xs={12}>
      <UploadReport setReport={setReport}/>
    </Grid>
    <Grid item md={1} xs={12}></Grid>
    {report && <Grid item md={12}>
    <Box mt={5}><Typography variant="h4">Your Funds</Typography></Box>
    <Box mt={3}><Charts report={report} /></Box>
    </Grid>}
    {report && <Grid item md={12}>
    <Box mt={5}><Typography variant="h4">Fund Detils</Typography></Box>
    <Box mt={3}><FundDetails funds={report.report} /></Box>
    </Grid>}
    {report && <Grid item md={12}>
    <Box mt={5}><Typography variant="h4">Funds By Timeline</Typography></Box>
    <Box mt={3}><FundGrowthChart funds={report.report} /></Box>
    </Grid>}
  </Grid>

}
export default LongTerm;